const entity = {
  name: {
    singular: 'Menu',
    plural: 'Menus'
  },
  collection: 'menus',
  tableHeaders: [
    { text: 'Título', value: 'title' },
    { text: 'Actions', value: 'action', sortable: false }
  ],
  model: {
    title: null,
    key: '',
    items: []
  },
  schema: {
    fields: [
      {
        type: 'input',
        inputType: 'text',
        label: 'Título',
        model: 'title',
        required: true
      },
      {
        type: 'input',
        inputType: 'text',
        label: 'Chave',
        model: 'key',
        required: true
      },
      {
        type: 'array',
        label: 'Items',
        model: 'items',
        translations: {
          title: 'Título',
          description: 'URL',
          position: 'Posição'
        }
      }
    ]
  },
  formOptions: {
    validateAfterLoad: false,
    validateAfterChanged: false,
    validateAsync: false
  }
}

export default [
  {
    path: '/menus',
    meta: {
      entity,
      requiresAuth: true
    },
    component: () => import(/* webpackChunkName: "menus" */ '../../components/Crud/CrudList.vue')
  }, {
    path: '/menus/new',
    meta: {
      entity,
      requiresAuth: true
    },
    component: () => import(/* webpackChunkName: "menus" */ '../../components/Crud/CrudForm.vue')
  }, {
    path: '/menus/:id',
    meta: {
      entity,
      requiresAuth: true
    },
    component: () => import(/* webpackChunkName: "menus" */ '../../components/Crud/CrudForm.vue')
  }
]
